import { useFormik } from 'formik';
import * as Yup from 'yup';

const NewSupervisingProviderValidationSchema = Yup.object().shape({
  first_name: Yup.string().min(2, 'First Name must be at least two characters'),
  last_name: Yup.string().min(2, 'Last Name must be at least two characters')
});

export const useSupervisingProviderFormik = (SPData, onSubmit) => {
  const formik = useFormik({
    initialValues: { number: '', first_name: '', last_name: '' },
    validationSchema: NewSupervisingProviderValidationSchema,
    enableReinitialize: true,
    onSubmit
  });

  return formik;
};

export const cols = [
  { field: 'number', headerName: 'NPI' },
  { field: 'first_name', headerName: 'First Name' },
  { field: 'last_name', headerName: 'Last Name' },
  {
    field: 'address',
    headerName: 'Address',
    cellRenderer: ({ value }) => {
      return value && `${value?.address_1}, ${value?.city} ${value?.state} ${value?.postal_code}`;
    },
    autoWidth: true
  }
];

export const DEFAULT_COL_DEFS = {
  enableRowGroup: false,
  resizable: true,
  filter: false,
  suppressMenu: true,
  suppressMovable: true
};

export const GRID_OPTIONS = {
  domLayout: 'autoHeight',
  animateRows: true
};

export const onGridReady = (params) => {
  const gridApi = params.api;

  gridApi.sizeColumnsToFit();
  gridApi.autoSizeColumns(['address']);
};
